import { render, staticRenderFns } from "./VersionApprovalModal.vue?vue&type=template&id=0c39701a&"
import script from "./VersionApprovalModal.vue?vue&type=script&lang=ts&"
export * from "./VersionApprovalModal.vue?vue&type=script&lang=ts&"
import style0 from "./VersionApprovalModal.vue?vue&type=style&index=0&id=0c39701a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports